import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { MatSelectChange } from '@angular/material/select';
import { AuthService } from '../../../../core/http/auth/auth.service';

@Component({
	selector: 'app-step1',
	templateUrl: './step1.component.html',
	styleUrls: ['./step1.component.scss'],
})
export class Step1Component {
	public propiedades: any = [];
	public units: any = [];

	constructor(private authService: AuthService, private _router: Router) {
		if (localStorage.getItem('residential_propierty'))
			this.propiedades = JSON.parse(
				localStorage.getItem('residential_propierty')
			);
		else this._router.navigateByUrl('/');
	}

	async changeResidentialUnit(event: MatSelectChange) {
		if (event.value) {
			let body = {
				language: localStorage.getItem('language'),
				id_propierty_unit: event.value,
			};

			let res: any = await this.authService.obtenerUnit(body);
			if (!res.mensaje_return.ERROR) {
				this.units = res.residential_propierty_unit;
			} else {
				// console.log('error al seleccionar residencia');
			}
		}
	}

	selectUnit(event: MatSelectChange) {
		localStorage.setItem('select_unit', event.value);
	}
}
